module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "5",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('features.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.banner_text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.02rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.banner_button'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "content1"
  }, [_c('div', {
    staticClass: "main_wrap center"
  }, [_c('ul', {
    staticClass: "bar_list clearfix",
    staticStyle: {
      "background": "#e8f4ff"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon4"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon5"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text3'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon6"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text4'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item1"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon7"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text5'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2 bar_item1"
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "content2 center"
  }, [_c('div', {
    staticClass: "push_SDK_title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('features.table1.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "push_SDK_text"
  }, [_c('table', {
    staticClass: "features_table"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label1')))]), _vm._v(" "), _c('td', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.4rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('features.table1.text1')))]), _c('div', {
    staticStyle: {
      "margin-bottom": "0.2rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('features.table1.text102')))]), _c('div', [_vm._v(_vm._s(_vm.$t('features.table1.text103')))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label11')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text2')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label12')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text3')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label13')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text4')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label14')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text5')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label15')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text6')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label16')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text7')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label17')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text8')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label18')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text9')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label19')))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.table1.text10'))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table1.label10')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table1.text11')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.22rem",
      "margin-top": "0.7rem",
      "padding-bottom": "0.7rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text11'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content3 center"
  }, [_c('div', {
    staticClass: "push_SDK_title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('features.table2.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "push_SDK_text"
  }, [_c('table', {
    staticClass: "features_table"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text1')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text2')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text3')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label4')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text4')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text5')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label6')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text6')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text7')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table2.label8')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table2.text8')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.22rem",
      "margin-top": "0.7rem",
      "padding-bottom": "0.7rem",
      "background": "#e8f4ff"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text11'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content2 center content4"
  }, [_c('div', {
    staticClass: "push_SDK_title",
    staticStyle: {
      "line-height": "1.5em"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('features.table3.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "push_SDK_text",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('table', {
    staticClass: "features_table"
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text1')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text2')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text3')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label4')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text4')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text5')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label6')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text6')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text7')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('features.table3.label8')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('features.table3.text8')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0.22rem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "requestion_wrap"
  }, [_c('div', {
    staticClass: "requestion"
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "padding-bottom": "1rem",
      "padding-top": "0.7rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/devolop"
    }
  }, [_c('a', {
    staticClass: "button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('features.text11'))
    }
  })])], 1)])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676bd0a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product3.vue
// module id = 94
// module chunks = 0